import React from 'react';
import { connect } from 'umi';

import MobileRevenue from './mobileRevenue';
import {
  IDataFrame,
  ISelectorState,
} from '@/pages/dashboard/types/dashboard';
import { IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';
import { PAGE_CONFIG as pcPageConfig } from '@/pages/dashboard/pages/monetization/pcConsoleRevenue/pageConfig';
import { casualPageConfig } from '@/pages/dashboard/pages/monetization/pcConsoleRevenue/casualPageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { IRevenueProps } from '@/pages/dashboard/pages/monetization/type';

const reqParams = '/monetization/revenue';

const pageMap: Partial<Record<IDataFrame, IPageConfigType>> = {
  casual: casualPageConfig as unknown as IPageConfigType,
  pc: pcPageConfig as unknown as IPageConfigType,
  mobile: pcPageConfig as unknown as IPageConfigType,
};

const dailyIndex = (props: IRevenueProps) => {
  const {
    data_frame: dataFrame = 'mobile',
  } = props;
  // date_frame = pc 表示页面为PC/Console的daily页面，ate_frame = mobile表示为之前的老daily页面
  const isMobile = dataFrame === 'mobile';
  const tabId = props?.match?.params?.tab;

  return (
    <>
      {isMobile ? (
        <MobileRevenue tabId={tabId} />
      ) : (
        <CommonPageRender
          reqParams={reqParams}
          pageConfigInit={pageMap?.[dataFrame]}
        />
      )}
    </>
  );
};

export default connect((state: ISelectorState) => {
  return {
    data_frame: state.dashboard?.currentGame?.data_frame || 'mobile',
  };
})(dailyIndex);
